import ChecklistRoundedIcon from '@mui/icons-material/ChecklistRounded';
import { Box, Button, Stack, Typography } from '@mui/material';

import { borderRadius } from '@verantos-dev/shared-ui-components/tokens';

import { reviewCardFrameSx } from './reviewStyles';

interface ReviewSkippedCardProps {
  title: string;
  headline: string;
  body: string;
  reopenLabel: string;
  disabled: boolean;
  onReopen: () => void;
}

/**
 * What a closed Review card becomes in the transcript, in the same card
 * chassis as the open card and the other chat cards. Reopening brings the open
 * card back with the picks made so far.
 */
export const ReviewSkippedCard = ({
  title,
  headline,
  body,
  reopenLabel,
  disabled,
  onReopen,
}: ReviewSkippedCardProps) => (
  <Stack spacing={2} data-testid="review-card-closed" sx={reviewCardFrameSx}>
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack direction="row" alignItems="center" spacing={1}>
        <ChecklistRoundedIcon sx={{ fontSize: 16, color: 'text.secondary' }} aria-hidden />
        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
      </Stack>
      <Box
        component="span"
        sx={{
          padding: (theme) => `${theme.spacing(0.5)} ${theme.spacing(2)}`,
          borderRadius: `${borderRadius.full}px`,
          typography: 'caption',
          color: 'text.secondary',
          backgroundColor: 'action.hover',
        }}
      >
        {headline}
      </Box>
    </Stack>
    <Typography variant="body2" color="text.secondary">
      {body}
    </Typography>
    <Box>
      <Button
        variant="text"
        size="small"
        onClick={onReopen}
        disabled={disabled}
        data-testid="review-reopen"
        sx={{ textTransform: 'none', paddingX: 0 }}
      >
        {reopenLabel}
      </Button>
    </Box>
  </Stack>
);
